import React, { type PropsWithChildren } from 'react';
import { StyleSheet, View } from 'react-native';

import { Container, HStack, theme, TitleText, useResponsive } from '@sg/garnish';

import { PARTNER_LINE_ITEM_CONTENT_MAX_WIDTH } from '../../PartnerLineItem.constants';

// ─────────────────────────────────────────────────────────────────────────────

export const PartnerLineItemIngredients = (props: Props) => {
  const { children, shouldUseCompactGrid, title } = props;

  const { match } = useResponsive();

  // ─── Styles ────────────────────────────────────────────────────────────────

  const sectionStyles = [styles.section, match([styles.sectionXS, undefined])];
  const containerStyles = [styles.innerContainer, match([styles.innerContainerXS, undefined])];
  const gap = match([theme.spacing['4'], theme.spacing['10']]);
  const itemsPerRow = shouldUseCompactGrid ? 3 : undefined;
  const stackStyles = match([undefined, styles.stackSM]);

  // ───────────────────────────────────────────────────────────────────────────

  return (
    <View style={sectionStyles}>
      <Container style={containerStyles}>
        <TitleText sizeMatch={['32', '40']} style={styles.title}>
          {title}
        </TitleText>

        <HStack gap={gap} itemsPerRow={itemsPerRow} style={stackStyles}>
          {children}
        </HStack>
      </Container>
    </View>
  );
};

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  section: {
    alignItems: 'center',
    alignSelf: 'stretch',
    borderTopWidth: 1,
    borderBottomWidth: 1,
    borderColor: theme.colors.BROWN,
    paddingTop: theme.spacing['15'],
    paddingBottom: theme.spacing['10'],
  },
  sectionXS: {
    paddingTop: theme.spacing['8'],
    paddingBottom: theme.spacing['6'],
  },
  innerContainer: {
    alignItems: 'center',
    gap: theme.spacing['10'],
    maxWidth: PARTNER_LINE_ITEM_CONTENT_MAX_WIDTH,
  },
  innerContainerXS: {
    paddingHorizontal: theme.spacing['6'],
  },
  stackSM: {
    rowGap: theme.spacing['4'],
  },
  title: {
    color: theme.colors.BROWN,
    alignSelf: 'stretch',
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type Props = PropsWithChildren<{
  shouldUseCompactGrid: boolean;
  title: string;
}>;
